import { Component, Input, OnInit, OnDestroy, SecurityContext } from "@angular/core";
import { SubSink } from "subsink";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { forkJoin, Observable, Subject, Subscriber, switchMap, takeUntil } from "rxjs";
import { EmitEvent, EventBusService } from "../../../core/services/event-bus.service";
import { SharedDataService } from "../../../shared/sharedData.service";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { OnboardingService } from "../../../shared/services/onboarding.service";
import { RemotesQueryService } from "../../../shared/services/remotesquery.service";
import { cloneDeep } from "lodash";
import { ContactService } from "../../../shared/services/contact.service";
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: "onboardinghistorylayout",
  templateUrl: "./history-layout-component.html",
  standalone: false
})

export class OnboardingHistoryLayoutComponent implements OnInit, OnDestroy {
  constructor(
    private _eventBus: EventBusService,
    private onboardingService: OnboardingService,
    private _sharedDataService: SharedDataService,
    private _talentQueryService: RemotesQueryService,
    public _modalService: BsModalService,
    private _contactService: ContactService,
    private log: NbcLoggerService,
    private sanitizer: DomSanitizer
  ) { }

  hrCounts: any | undefined;
  componentDestroyed$: Subject<boolean> = new Subject();
  private subs = new SubSink();
  onboardingMasterData: any[] = [];
  employeeTypes: any;
  requestStatus: any;
  companyCodes: any;
  contactTypes: any;
  registrationStatus: any;
  selectedRequestStatus: any = "";
  selectedRegistrationStatus: any = "";
  selectedEmployeeType: any = "";
  selectedContactType: any = "";
  selectedBusinessUnit: any;
  searchTextboxEnable: any = true;
  goButtonEnable: any = true;
  contactObservable$: Observable<any[]> | undefined;
  contactSearchTerm = "";
  hasContactSelected = false;

  selectSearchCriteria: any = {
    optionValue: "0",
    optionDescription: "",
  };

  gridData: any = {
    items: [],
    query: ''
  };

  bsModalRef?: BsModalRef;

  queryContainer: any | undefined;
  childwindows = [];
  newWindow = null;

  pageSizeList: any[] = [10, 25, 50, 100];

  searchCriteria: any = [
    { optionValue: "1", optionDescription: "Contact Name" },
  ];


  itemCount1 = 0;
  itemCount2 = 0;
  itemCount3 = 0;
  itemCount4 = 0;
  itemCount5 = 0;
  itemCount6 = 0;
  itemCount7 = 0;


  changeSearchCriteria(): void {
    if (
      this.selectSearchCriteria.optionValue &&
      this.selectSearchCriteria.optionValue != 0
    ) {
      this.queryContainer.query.searchTerm.id =
        this.selectSearchCriteria.optionValue;
      this.enableSearchButton();
    } else {
      this.queryContainer.query.searchTerm.description = "";
      this.disableSearchButton();
    }
  }

  disableSearchButton(): void {
    this.goButtonEnable = true;
    this.searchTextboxEnable = true;
    this.queryContainer.query.searchTerm.description = "";
  }

  enableSearchButton(): void {
    this.goButtonEnable = false;
    this.searchTextboxEnable = false;
    this.queryContainer.query.searchTerm.description = "";
  }

  onContactSearchTermSelect($searchTerm): void {
    this.queryContainer.query.searchTerm.description =
      $searchTerm?.item?.fullName;
    this.queryContainer.query.searchTerm.name = $searchTerm?.item?.id;
  }

  changeTypeaheadLoading($event) { }

  contactTypeahead() {
    this.hasContactSelected = false;
    this.contactObservable$ = new Observable(
      (observer: Subscriber<string>) => {
        observer.next(this.contactSearchTerm);
      }
    ).pipe(
      takeUntil(this.componentDestroyed$),
      switchMap((token: string) => {
        this.queryContainer.query.searchTerm.description = token; //contact name fuzzy search
        return this._contactService.searchByName(
          encodeURIComponent(token)
        );
      })
    );
  }


  changeRequestStatus() {
    if (this.selectedRequestStatus?.id) {
      this.queryContainer.query.requestStatusId =
        this.selectedRequestStatus.id;
    } else {
      this.queryContainer.query.requestStatusId = null;
    }
    this.queryContainer.query.currentPage = 1;
    this.search();
  }

  restartSearch(): void {
    this.queryContainer = {
      query: this._talentQueryService.getHrOnboardingHistoryTabQuery(),
    };
    this.queryContainer.query.requestStatusId = 0;

    this.selectedRequestStatus = "";
    this.selectedEmployeeType = "";
    this.selectedContactType = "";
    this.selectedRegistrationStatus = "";
    this.search();
    this.goButtonEnable = true;
    this.searchTextboxEnable = true;
    this.contactSearchTerm = "";
    this.selectSearchCriteria = "";
  }


  sortColumn(column) {
    if (this.queryContainer.query.sortByColumn === column) {
      this.queryContainer.query.reverseSort =
        !this.queryContainer.query.reverseSort;
    } else {
      this.queryContainer.query.sortByColumn = column;
      this.queryContainer.query.reverseSort = false;
    }
    this.search();
  }

  searchPage(pageSize) {
    this.queryContainer.query.pageSize = pageSize;
    this.search();
  }

  requestStatusSearch(status) {
    this.queryContainer.query.requestStatusId = status;
    this.search();
  }

  search(): void {
    this.log.trace("OnboardingRequest -> Search() called");
    this.queryContainer.query.businessUnitId = this.selectedBusinessUnit?.id;
    const onboardingQuery = cloneDeep(this.queryContainer);
    this.onboardingService
      .search(onboardingQuery.query,"history")
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        (data) => {
          this.log.trace(
            "OnboardingRequest -> Search(): Data received"
          );

          this.queryContainer.query.totalRecords =
            data.reference.totalRecords;
          this.gridData.items = data.reference.items;
          this.gridData.query = this.queryContainer.query;

          setTimeout(() => {
            this._eventBus.emit(
              new EmitEvent(
                "onboard-request:search",
                "buildOnboardingHistoryGrid",
                this.gridData
              )
            );
          }, 300);
        },
        (err) => {
          this.log.error(err);
          this.log.showError(err.message);
        },
        () => {
          this.log.trace("OnboardingRequest -> removing spinner");
        }
      );
  }
  getTalentPermission() {
    const userRoles = window.preload?.user?.userRoles || [];

    const sfModalView = _.find(userRoles, { description: "Payroll SU" })
      ? "talent_payroll"
      : _.find(userRoles, { description: "Talent SU" })
        ? "talent_su"
        : null;

    return sfModalView;
  }

  openHrOnboardingPositionModal(hrOnboardingItem) {
    const crewRegNo = hrOnboardingItem.registrationNo;
    const sfViewName = this.getTalentPermission();
    var url = "";
    var modalSharedResource = {
      userSSO: "900001885",
      regNumber: crewRegNo,
      view: sfViewName,
      "subtab": "registration",
      "accessLevel": "Edit"
    };
    this.onboardingService.getSFModalURL(modalSharedResource,hrOnboardingItem?.businessUnitId)
      .subscribe({
        next: (result: any) => {
          url = result.reference;
          const settings =
            "top=125,left=280,width=800,height=775,location=0,titlebar=0";

          const newWindow = window.open(url, crewRegNo, settings);

          for (let i = 0; i < this.childwindows.length; i++) {
            if (
              this.childwindows[i] &&
              this.childwindows[i] == newWindow &&
              this.childwindows[i].opened
            ) {
              this.childwindows.splice(i, 1);
              this.childwindows[i].close();
            }
          }
          this.childwindows[this.childwindows.length] = newWindow;
          if (newWindow) {
            newWindow.focus();
          }
        },
        error: (err: any) => {
          this.log.showError(err.error.message);
        }
      });
    return false;
  }


  getOnboardingCounts() {

    this.onboardingService.getTalentOnboardingCount(this.selectedBusinessUnit?.id).pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        data => {
          this.log.trace("OnboardingHeader -> getHrCounts: data received");
          this.itemCount1 = data.reference.positionRequestsSubmitted;
          this.itemCount2 = data.reference.registrationsSubmitted;
          this.itemCount3 = data.reference.registrationsApproved;
          this.itemCount4 = data.reference.onboardingsInprogress;
          this.itemCount5 = data.reference.requestsComplete;
          this.itemCount6 = data.reference.registrationsRejected;
          this.itemCount7 = data.reference.registrationsCancelled;
        },
        err => {
          this.log.error(err);
        },
        () => {
          this.log.trace("OnboardingHeader -> removing spinner");
        });

  }

  getMasterData() {
    this.subs.sink = this.onboardingService.getOnboardingDashboardMasterData("history").pipe(takeUntil(this.componentDestroyed$)).subscribe({
      next: (result) => {
        this.onboardingMasterData = result.reference;
        this.employeeTypes = result.reference.employeeTypes;
        this.requestStatus = result.reference.onboardingStatus;
        this.registrationStatus = result.reference.registrationStatus;
        console.log(result.reference);
      },
      error: (err) => {
        this.log.showError("Business Units failed to load");
      },
    });
  }

  onBusinessUnitSelected(data: any) {
    this.selectedBusinessUnit = data;
    console.log(this.selectedBusinessUnit);
  }

  subscribeEventHandlers() {
    this.subs.sink = this._sharedDataService
      .getSelectedBusinessUnit()
      .subscribe((selectedBu) => this.onBusinessUnitSelected(selectedBu));

    this.subs.sink = this._eventBus.on("changeSortColumn", (dataSource) => this.sortColumn(dataSource));
    this.subs.sink = this._eventBus.on("openHrOnboardingPositionModal", (hrOnboardingItem) => this.openHrOnboardingPositionModal(hrOnboardingItem));

  }


  ngOnInit() {
    this.subscribeEventHandlers();
    this.contactTypeahead();
    this.queryContainer = {
      query: this._talentQueryService.getHrOnboardingHistoryTabQuery()
    };
    this.gridData.query = this._talentQueryService.getHrOnboardingHistoryTabQuery();
    this.getOnboardingCounts();
    this.getMasterData();
    this.search();
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
    this.subs.unsubscribe();
  }
}
